import { Pipe, PipeTransform } from '@angular/core'
import {
  DeviceTypeEnum,
  ElevatorSubType,
  EscalatorSubType,
  FireAlarmSubType,
  DoorSubType,
  HvacSubType,
} from '@wm-front/admin/graphql'
import { ElevatorType } from '@wm-front/client/graphql'

export type DeviceType =
  | DeviceTypeEnum
  | ElevatorType
  | EscalatorSubType
  | ElevatorSubType
  | FireAlarmSubType
  | DoorSubType
  | HvacSubType

@Pipe({
  name: 'deviceType',
  standalone: true,
})
export class DeviceTypePipe implements PipeTransform {
  /** Transform device type into localised string
   * @returns { string }
   * @param value
   * @param plural
   */
  public transform(value: DeviceType, plural = 1): string {
    switch (value) {
      case ElevatorType.Elevator:
      case ElevatorSubType.Elevator:
      case DeviceTypeEnum.Elevator:
        return plural <= 1
          ? $localize`:Info Value | Value for the device type elevator@@deviceTypeElevatorLabel:Ascenseur`
          : $localize`:Info Value | Value for the device type elevator plural@@deviceTypeElevatorsLabel:Ascenseurs`
      case ElevatorType.PlatformLift:
      case ElevatorSubType.PlatformLift:
        return plural <= 1
          ? $localize`:Info Value | Value for the device type platform lyft@@deviceTypePlatformLiftLabel:Ascenseur pour personnes à mobilité réduite`
          : $localize`:Info Value | Value for the device type platform lyft plural@@deviceTypePlatformLiftsLabel:Ascenseurs pour personnes à mobilité réduite`
      case ElevatorType.FreightElevator:
      case ElevatorSubType.FreightElevator:
        return plural <= 1
          ? $localize`:Info Value | Value for the device type freight elevator@@deviceTypeFreightElevatorLabel:Monte charges`
          : $localize`:Info Value | Value for the device type freight elevator plural@@deviceTypeFreightElevatorsLabel:Monte charges`
      case DeviceTypeEnum.Escalator:
      case EscalatorSubType.Escalator:
        return plural <= 1
          ? $localize`:Info Value | Value for the device type escalator@@deviceTypeEscalatorLabel:Escalator`
          : $localize`:Info Value | Value for the device type escalator plural@@deviceTypeEscalatorsLabel:Escalators`
      case DeviceTypeEnum.FireAlarm:
      case FireAlarmSubType.FireAlarm:
      case FireAlarmSubType.FireSafety:
        return plural <= 1
          ? $localize`:Info Value | Value for the device type fire alarm@@deviceTypeFireAlarmLabel:Sécurité incendie`
          : $localize`:Info Value | Value for the device type fire alarm plural@@deviceTypeFireAlarmsLabel:Sécurité incendies`
      case DeviceTypeEnum.Door:
      case DoorSubType.AutomaticDoor:
      case DoorSubType.ManualDoor:
      case DoorSubType.RollerShutter:
        return plural <= 1
          ? $localize`:Info Value | Value for the device type door@@deviceTypeDoorLabel:Porte`
          : $localize`:Info Value | Value for the device type door plural@@deviceTypeDoorsLabel:Portes`
      case DeviceTypeEnum.Hvac:
      case HvacSubType.Hvac:
        return plural <= 1
          ? $localize`:Info Value | Value for the device type hvac@@deviceTypeHvacLabel:CVC`
          : $localize`:Info Value | Value for the device type hvac plural@@deviceTypeHvacsLabel:CVC`
      default:
        return $localize`:Info Value | Value for the device type unavailable@@deviceTypeUnvailableLabel:Indisponible`
    }
  }
}
